"use client";
import React from "react";

const MinuteOption = ({ setSelectedMinute, hideDropdown }) => {
  const minutes = [
    "00",
    "05",
    "10",
    "15",
    "20",
    "25",
    "30",
    "35",
    "40",
    "45",
    "50",
    "55",
  ];
  const handleMinuteSelection = (minute) => {
    setSelectedMinute(minute);
    hideDropdown();
    localStorage.setItem("selectedMinute", JSON.stringify(minute));
  };
  return (
    <div className="w-full rounded-lg grid grid-cols-4 text-center">
      {minutes.map((minute) => (
        <div
          className="text-lg appearance-none outline-none p-2 hover:text-[#2B3252] cursor-pointer hover:bg-[#F7EFD6] rounded-full"
          key={minute}
          onClick={() => handleMinuteSelection(minute)}
        >
          {minute}
        </div>
      ))}
    </div>
  );
};
export default MinuteOption;
